import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';

export interface ContactPayload {
  name: string;
  email: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ContactService {
  constructor(private readonly http: HttpClient) {}

  submit(payload: ContactPayload): Observable<{ ok: true }> {
    return this.http.post<{ ok: true }>(`${API_BASE_URL}/contact`, payload);
  }
}
